<template>
  <tr class="bg-blue-50 dark:bg-blue-900/50" :class="{ 'opacity-75': loading }">
    <!-- Sipariş -->
    <td class="px-3 py-2" style="width: 250px;">
      <orderInput
        :hideContainer="true"
        title="1"
        v-model="orderId"
        :isBulk="true"
        :disabled="loading"
        @changeObject="(val) => { selected = val; }"
      />
    </td>
    
    <!-- Müşteri -->
    <td class="px-3 py-2">
      <span class="text-xs text-gray-500 italic">{{ selected.customer || 'Seçilecek' }}</span>
    </td>
    
    <!-- Miktar -->
    <td class="px-3 py-2">
      <span class="text-xs text-gray-500">{{ selected.amount || '--' }} ton</span>
    </td>
    
    <!-- Rota -->
    <td class="px-3 py-2">
      <div v-if="!loading" class="text-xs text-gray-500 space-y-1">
        <div>📍 {{ selected.outpointAdress || 'Yükleme' }}</div>
        <div>📍 {{ selected.targetAdress || 'Teslim' }}</div>
      </div>
      <div v-if="loading" class="text-xs text-blue-600 italic flex items-center">
        <div class="w-3 h-3 border border-blue-600 border-t-transparent rounded-full animate-spin mr-1"></div>
        Hesaplanıyor...
      </div>
    </td>
   <!-- Araç Türü -->
    <td class="px-3 py-2">
      <span v-if="!loading" class="text-xs text-gray-500">--</span>
    </td>
    
    <!-- Araç -->
    <td class="px-3 py-2">
      <span v-if="!loading" class="text-xs text-gray-500">--</span>
      <span v-if="loading" class="text-xs text-blue-600">Hesaplanıyor...</span>
    </td>
    
    <!-- Tür -->
    <td class="px-3 py-2">
      <span class="text-xs text-gray-500">--</span>
    </td>
    
    <!-- Mesafe -->
    <td class="px-3 py-2">
      <span v-if="!loading" class="text-xs text-gray-500">--</span>
      <span v-if="loading" class="text-xs text-blue-600">Hesaplanıyor...</span>
    </td>
    
    <!-- Tarih -->
    <td class="px-3 py-2">
      <span class="text-xs text-gray-500">{{ selected.deliveryDate ? new Date(selected.deliveryDate).toLocaleDateString() : '--' }}</span>
    </td>
    
    <!-- İşlemler -->
    <td class="px-3 py-2">
      <div class="flex space-x-1">
        <button
          type="button"
          :disabled="loading || !orderId"
          class="w-8 h-8 bg-green-500 hover:bg-green-600 disabled:bg-gray-300 text-white rounded-md transition-colors duration-200 flex items-center justify-center relative"
          @click="handleAddOrder"
        >
          <i v-if="!loading" class="fas fa-plus text-xs"></i>
          <div v-if="loading" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        </button>
        <button
          :disabled="loading"
          type="button"
          class="w-8 h-8 bg-gray-400 hover:bg-gray-500 disabled:bg-gray-300 text-white rounded-md transition-colors duration-200 flex items-center justify-center"
          @click="handleReset"
        >
          <i class="fas fa-times text-xs"></i>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import orderInput from "@/components/devItem/orderInput.vue";
import diffInput from "@/components/general/diffInput.vue";

export default {
  name: "NewOrderRow",
  components: {
    orderInput,
    diffInput,
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderId: "",
      selected: {
        amount: "",
        deliveryDate: "",
        targetAdress: "",
        customer: "",
        outpointAdress: "",
      },
    };
  },
  methods: {
    handleAddOrder() {
      if (this.orderId === "") {
        this.swalBox(
          "warning",
          "UYARI!",
          "LÜTFEN ÖNCE BİR SİPARİŞ SEÇİN...",
          false,
          "Tamam"
        );
        return;
      }
      this.$emit('add-order', {
        orderId: this.orderId,
        selected: this.selected
      });
    },
    swalBox(icon, title, text, showCancel, confirmText) {
      this.$swal.fire({
        icon: icon,
        title: title,
        text: text,
        showCancelButton: showCancel,
        confirmButtonText: confirmText
      });
    },
    handleReset() {
      this.resetFormInternal();
      this.$emit('reset');
    },
    resetFormInternal() {
      this.orderId = "";
      this.selected = {
        amount: "",
        deliveryDate: "",
        targetAdress: "",
        customer: "",
        outpointAdress: "",
      };
    },
    resetForm() {
      // Called from parent - don't emit to prevent infinite loop
      this.resetFormInternal();
    }
  },
};
</script>